import TextS from './TextS';

export default TextS;
